import { useEffect, useState } from "react";
import { socket } from "@/shared/config/socket";
import { formatUSD } from "@/shared/utils/ultils";

interface Props {
  setIdMarket: any;
  idMarket: number;
}
const SelectMarket = ({ setIdMarket, idMarket = 1 }: Props) => {
  const [showSelect, setShowSelect] = useState(false);
  const [markets, setMarkets] = useState([]);
  useEffect(() => {
    socket.on("get_prices", (data: any) => {
      setMarkets(data);
    });
  }, []);
  const marketActive: any = markets?.find((item: any) => item?.id === idMarket);
  return (
    <div className="mt-3">
      <div className="mb-2" style={{ color: "#fff", fontSize: 14 }}>
        Chọn hàng hoá
      </div>
      <div
        onClick={() => setShowSelect(!showSelect)}
        className="py-3 px-3 rounded-3 cursor-pointer d-flex justify-content-between position-relative"
        style={{
          fontSize: 14,
          background: "rgb(7, 15, 33)",
          color: "#fff",
          border: "none",
          boxShadow: "none",
        }}
      >
        <div>
          <img
            className="rounded-circle me-2"
            width={25}
            src={
              `https://faofood.com/assets/images/commodity/` +
              marketActive?.image
            }
          />
          {marketActive?.name}
        </div>
        <div>{formatUSD(marketActive?.price)}</div>
        <div>
          {marketActive?.twenty_four_hour_change}%{" "}
          {marketActive?.twenty_four_hour_change > 0 ? (
            <i
              style={{ color: "hsl(152 69% 31%)" }}
              className="fa-solid fa-arrow-trend-up"
            ></i>
          ) : (
            <i
              style={{ color: "hsl(354 70% 54%)" }}
              className="fa-solid fa-arrow-trend-down"
            ></i>
          )}
        </div>

        <div
          className="box-select-tiente-1 w-100"
          style={{ display: showSelect ? "block" : "none" }}
        >
          {markets?.map((item: any, index: number) => (
            <div
              className="py-3 px-3 item d-flex justify-content-between align-items-center"
              key={index}
              onClick={() => setIdMarket(item?.id)}
            >
              <div>
                <img
                  className="rounded-circle me-2"
                  width={25}
                  src={
                    `https://faofood.com/assets/images/commodity/` + item?.image
                  }
                />
                {item?.name}
              </div>
              <div>{formatUSD(item?.price)}</div>
              <div>
                {item?.twenty_four_hour_change}%{" "}
                {item?.twenty_four_hour_change > 0 ? (
                  <i
                    style={{ color: "hsl(152 69% 31%)" }}
                    className="fa-solid fa-arrow-trend-up"
                  ></i>
                ) : (
                  <i
                    style={{ color: "hsl(354 70% 54%)" }}
                    className="fa-solid fa-arrow-trend-down"
                  ></i>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* <CFormSelect value={idMarket ?? 1} onChange={(e) => setIdMarket(e.target.value)} className="py-3" style={{ fontSize: 14, background: "rgb(7, 15, 33)", color: "#fff", border: "none", boxShadow: "none"}}>
        {markets?.map((item: any, index: number) => (
            <option key={index} value={item?.id}>
                {item.name}
              </option>
          ))}
      </CFormSelect> */}
    </div>
  );
};

export default SelectMarket;
